import { clientApi } from '../../configuration';
import { getPermissionListHook } from '../../utils';

type OnboardingPermissionCodes =
  | 'COMPLETE_ONBOARDING'
  | 'RECRUITER_ONBOARDING_JOB_POSTING_CREATION';

const useOnboardingsPermissions = getPermissionListHook<OnboardingPermissionCodes, 'onboardings'>({
  entityName: 'onboardingsPermissions',
  apiResponseRootKey: 'onboardings',
  fetch: () => clientApi.getOCClient().helpers.user.me.getOnboardingsPermissions(),
});

export default useOnboardingsPermissions;
